export const useFilterOptionsShorter = (items = []) => {
  const visibleItems = items.slice(0, 4)
  const hiddenItems = items.slice(4)

  return {
    visibleItems,
    hiddenItems
  }
}

